import React, { useEffect, useState } from "react";
import {
  Avatar,
  Backdrop,
  Button,
  DevNote,
  FormFieldSet,
  LogoLoader,
  Modal,
  NewTableAdv,
  showToast,
  StatusTags,
  useFormHandler,
} from "../../../../components";
import qb from "../../../../assets/qb.svg";
import { dateFormator, mapTableRows } from "../../../../utils";
import { DropDownoptionsquickbooks } from "../../../../assets/data/projectData";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  qbApiStart,
  resetAllQBData,
} from "../../../../redux/slices/quickBooks/quickBooksSlice";
import { usePagination } from "../../../../hooks";
import { getAccountPayablesStart, updateAccountPayablesStart } from "../../../../redux/slices/accountPayables/accountPayablesSlice";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import QbAnimationLoading from "../../../../components/Module/Invoices/InvoiceModals/QbAnimationLoading";
import { select } from "redux-saga/effects";
import { WORKFORCE_API_URL } from "../../../../redux/apiConfig";
import axios from "axios";
import ApInvoiceDetails from "../../AccountsPayable/Modals/ApInvoiceDetails";

const APInvoice = ({ setActiveTab, dropdowns }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [qbLoading, setQbLoading] = useState(false);
  const [forceRerenderKey, setForceRerenderKey] = useState(0);
  const [sortConfig, setSortConfig] = useState({
    field: "uiid",
    direction: -1,
  });

  const { loading, error, accountPayables } = useSelector(
    (state) => state.accountPayables
  );

  const { value } = useSelector((state) => state.totalCount);

  const totalCount = value?.accountpayables?.data;

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      // dispatch(getAccountPayablesStart({ page: newPage, limit: newLimit }));
    }
  );

  //const tablerowData = accountPayables;
  const tablerowData = accountPayables?.data || []; // Add null check with default empty array
  // Handle sort function
  const handleSort = (field) => {
    setSortConfig((prevSort) => ({
      field,
      // Toggle between 1 (ascending) and -1 (descending)
      direction: prevSort.field === field ? -prevSort.direction : -1,
    }));
  };

  const { formData, errors, handleChange, validateAllFields } = useFormHandler({
    Placement: "",
    documentType: "",
    status: "",
  });
  const columns = [
    {
      key: "invoiceNumber",
      label: "Invoice Number",
      render: (row) => (
        <span
          className={`flex gap-2 items-center cursor-pointer ${
            row?.qbSync?.id
              ? "text-success"
              : row?.qbSync?.error
              ? "text-danger"
              : "text-linkblue"
          }`}
          onClick={() => setSelectedInvoice(row?.id)}
        >
          {row.invoiceNumber}
        </span>
      ),
      sortable: false,
    },

    {
      key: "businessUnit",
      label: "Business Unit",
      sortable: false,
    },
    {
      key: "recordType",
      label: "Record Type",
      sortable: false,
    },
    {
      key: "vendor",
      label: "Vendor",
      sortable: false,
    },
    {
      key: "employees",
      label: "Employees",
      sortable: false,
    },
    {
      key: "invoicDate",
      label: "Invoice Date",
      sortable: false,
    },
    {
      key: "dueDate",
      label: "Due Date",
      sortable: false,
    },

    {
      key: "invoiceAmount",
      label: "Invoice Amount",
      sortable: false,
    },
    {
      key: "paidAmount",
      label: "Paid Amount",
      sortable: false,
    },

    {
      key: "syncstatus",
      label: "Sync Status",
      sortable: false,
    },
  ];

  const rowdata = [
    {
      invoiceNumber: "INV-2001",
      businessUnit: "Tektree",
      recordType: "Ap invoice",
      vendor: "ABC Vendors Pvt Ltd",
      employees: "John Doe, Jane Smith",
      invoicDate: "06/01/2025",
      dueDate: "06/30/2025",
      invoiceAmount: "45,000 USD",
      paidAmount: "45,000 USD",
      syncstatus: "Not Synced",
    },
    {
      invoiceNumber: "INV-2002",
      businessUnit: "Tektree",
      recordType: "Ap invoice",
      vendor: "XYZ Supplies",
      employees: "Emily Clark",
      invoicDate: "06/10/2025",
      dueDate: "07/10/2025",
      invoiceAmount: "25,000 USD",
      paidAmount: "10,000 USD",
      syncstatus: "Not Synced",
    },
    {
      invoiceNumber: "INV-2003",
      businessUnit: "Tektree",
      recordType: "Ap invoice",
      vendor: "TechWave LLC",
      employees: "Arjun Reddy, Ravi Teja",
      invoicDate: "06/15/2025",
      dueDate: "06/30/2025",
      invoiceAmount: "60,000 USD",
      paidAmount: "60,000 USD",
      syncstatus: "Not Synced",
    },
  ];
  const fetchInvoices = async () => {
    dispatch(
      qbApiStart({
        method: "GET",
        entity: "bills",
        // body: {
        //
        // },
      })
    );
  };
  const rowData2 = tablerowData?.map((item) => ({
    id: item?.uiid,
    qbSync: item?.qbSync,
    invoiceNumber: item?.invoiceNum || "-",
    businessUnit: "-",
    recordType: "-",
    vendor: item?.vendorId?.businessName || "-",
    employees:
      item?.employeeId
        ?.map((emp) => `${emp.firstName} ${emp.lastName}`)
        .join(", ") || "-",
    invoicDate: dateFormator(item?.invoiceDate, "month-day-year") || "-",
    dueDate: dateFormator(item?.dueDate, "month-day-year") || "-",
    invoiceAmount: item?.amounts?.billed || "-",
    paidAmount: item?.amounts
      ? (item?.amounts?.paid).toString()
      : item?.amounts?.paid || "-",
    syncstatus: item?.qbSync?.id ? "Synced" : "Unsynced",
  }));
  const mappedRows = mapTableRows(rowData2, columns);

  useEffect(() => {
    dispatch(
      getAccountPayablesStart({
        limit,
        page,
        filters: {
          //employmentType: { type: "NONE", value: 3 },
          //"isExit.status": { type: "NONE", value: false },
          // onBench: { type: "NONE", value: false },
        },
        // ret: "uiid invoiceNum employeeId vendorId invoiceDate dueDate amounts addedOn modifiedOn isModified",
        ref: "Employee Vendor",
        // incl: ["firstName lastName", "businessName"],
        incl: ["firstName lastName", ""],
        sort: { [sortConfig.field]: sortConfig.direction },
      })
    );
    dispatch(
      totalCountStart({
        collection: "accountpayables",
        coll: "AccountPayable",
        //filters: item.filters,
      })
    );
  }, [dispatch, page, limit, sortConfig, forceRerenderKey]);
  const handleSearch = () => {
    setActiveTab(Number(formData.Timesheets));
  };

  const forceRerender = () => {
    setForceRerenderKey((prevKey) => prevKey + 1);
  };

  const handleQbSync = async (entity) => {
    if (selectedRowIds.length === 0) {
      showToast("Please select at least one invoice", "info", 5000);
      return;
    }
    let baseUrl = WORKFORCE_API_URL;
    try {
      setQbLoading(true);

      const selectedIds = selectedRowIds;
      const invoiceData = tablerowData?.filter((invoice) =>
        selectedIds.includes(invoice.uiid)
      );

      let successCount = 0;
      let failedCount = 0;

      const buildVendorPayload = (data) => ({
        postActions: ["AddQBToVendor"],
        payload: {
          businessName: (data.businessName || "").replace(/[^\w\s]/g, ""),
          uiid: data.uiid || null,
          dbaName: data?.dbaName || "",
          email: data?.email,
          phone: data?.phone,
          website: data?.website,
          generalInfo: {
            locations: data?.generalInfo?.locations,
            recorsStatus: data?.generalInfo.recordStatus,
          },
        },
      });

      const buildAPInvoicePayload = (invoice) => {
        const obj = invoice;
        return {
          ...(obj?.qbSync?.id && { qbSync: obj.qbSync }),
          uiid: obj?.uiid,
          invoiceNum: obj?.invoiceNum || undefined,
          invoiceBy: obj?.vendorId,
          employeeId: obj?.employeeId?.map((item) => item?.uiid),
          approverId: obj?.approverId,
          vendorId: obj?.vendorId?.uiid,
          //as said incoive date is same a s billed dated
          invoiceDate: obj?.invoiceDate || undefined,
          billedDate: obj?.billedDate || undefined,
          dueDate: obj?.dueDate || undefined,
          netTerms: obj?.netTerms || undefined,
          amounts: obj?.amounts,
          // isModify: true,
          status: obj.status,
          category: obj?.category || undefined,
          type: obj?.type || undefined,
          mailAddress: obj?.mailAddress || undefined,
          contacts: obj?.InvoiceContacts || undefined,
          emails: obj?.emails || undefined,
          invoiceDetails: obj?.invoiceDetails,
          discount:
            obj?.discounts?.map((item) => ({
              name: item?.name || undefined,
              type: item?.type || undefined,
              value: Number(item?.value) || undefined,
            })) || [],
          memo: obj?.memo || undefined,
          comments: obj?.comments || undefined,
        };
      };

      for (const invoice of invoiceData) {
        const vendorData = invoice.vendorId || {};
        const isVendorSynced = Boolean(vendorData?.qbSync?.id);

        if (!isVendorSynced) {
          try {
            const vendorPayload = buildVendorPayload(vendorData);
            await axios.post(`${baseUrl}/qb/vendors`, vendorPayload, {
              headers: { "Content-Type": "application/json" },
              withCredentials: true,
            });
          } catch (err) {
            showToast(
              `${err?.response?.data?.error || "Unknown error"}`,
              "warning",
              5000
            );
            console.error("Vendor Sync Failed:", err.response || err);
            failedCount++;
            continue;
          }
        }

        const isAPInvoiceSynced = Boolean(invoice?.qbSync?.id);
        const invoicePayload = buildAPInvoicePayload(invoice);

        try {
          if (!isAPInvoiceSynced) {
            const res = await axios.post(
              `${baseUrl}/qb/${entity}`,
              {
                postActions: ["AddQBToAccPay"],
                payload: invoicePayload,
              },
              {
                withCredentials: true,
                headers: { "Content-Type": "application/json" },
              }
            );
            successCount++;
          } else {
            const res = await axios.post(
              `${baseUrl}/qb/${entity}`,
              {
                update: true,
                postActions: ["AddQBToAccPay"],
                payload: invoicePayload,
              },
              {
                withCredentials: true,
                headers: { "Content-Type": "application/json" },
              }
            );
            dispatch(
              updateAccountPayablesStart({
                coll: "AccountPayable",
                uiid: invoicePayload?.uiid,
                qbId: invoicePayload?.qbSync?.id,
                syncFromQB: true,
                supressToast: true,
              })
            );
            successCount++;
          }
        } catch (err) {
          showToast(
            `${err?.response?.data?.error || "Unknown error"}`,
            "warning",
            5000
          );

          console.error("Invoice Sync Error:", err);
          failedCount++;
        }
      }

      showToast(
        `QB Update Done: ${successCount} succeeded, ${failedCount} failed.`,
        failedCount > 0 ? "warning" : "success",
        6000
      );
    } catch (err) {
      console.error("Unexpected QB Sync Error:", err);
      showToast("Unexpected Error Occurred", "error", 5000);
    } finally {
      setQbLoading(false);
      forceRerender();
    }
  };

  return (
    <div className="flex flex-col overflow-hidden flex-1">
      <QbAnimationLoading
        isOpen={qbLoading}
        onClose={() => setQbLoading(false)}
      />
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
      <NewTableAdv
        onSelectionChange={(selected) => {
          setSelectedRowIds(selected);
        }}
        rows={mappedRows}
        columns={columns}
        showCheckbox
        serverPagination={true}
        totalCount={totalCount}
        page={page}
        limit={limit}
        onPageChange={setPage}
        onLimitChange={handleLimitChange}
        toolbarRight={{
          search: false,
          filter: false,
          download: false,
          add: [
            {
              component: (
                <div className=" flex flex-wrap gap-4 m-2 items-center ">
                  <FormFieldSet
                    type="text"
                    noTitle
                    placeholder="Invoice No, Client, Employee"
                    value={formData.Search || ""}
                    onChange={(value) => handleChange("Search", value)}
                    error={errors.Search}
                  />
                  <FormFieldSet
                    type="select"
                    noTitle
                    placeholder="Select Timesheets"
                    value={formData.Timesheets || ""}
                    // onChange={(value) => setActiveTab(value)}
                    onChange={(value) => handleChange("Timesheets", value)}
                    error={errors.Timesheets}
                    options={dropdowns}
                  />
                  <FormFieldSet
                    type="select"
                    noTitle
                    placeholder="Select Status"
                    value={formData.status || ""}
                    onChange={(value) => handleChange("status", value)}
                    error={errors.status}
                    options={""}
                    showSearch
                  />
                
                    <Button title="Search" onClick={handleSearch} />
                  
                  
                    <Button
                      title="QB Integration Profiles"
                      color="info"
                      onClick={() =>
                        navigate("/quickbooks/qb-integration-profile")
                      }
                    />
                
                  {selectedRowIds.length > 0 && (
                    <div className="mt-5 flex items-center">
                      {/* <button
                        onClick={() => handleQbSync("bills")}
                        className="mx-1"
                      >
                        <Avatar src={qb} alt={"qb"} size="xs" outline />
                      </button>*/}
                    </div>
                  )}
                </div>
              ),
            },
          ],
        }}
      />
      <Modal
        isOpen={selectedInvoice}
        title={"AP Invoice Details"}
        onClose={() => setSelectedInvoice(null)}
        showCloseButton={true}
        closeOnOutsideClick={true}
        width="max-w-full"
        zIndex={56}
      >
        <ApInvoiceDetails
          invoiceUiid={selectedInvoice}
          onBack={() => setSelectedInvoice(null)}
          removeButtonForPreview={false}
        />
      </Modal>
    </div>
  );
};

export default APInvoice;
